import {html, render} from 'lit-html';
import state from "../state";
import { statsNav } from "./templates/stats-nav";

class StatsNavView {
  constructor() {
    this.dom = document.querySelector("#stats-nav");
    this.selector = {
      metric: "cases",
      frequency: "total",
      count: ""
    }

    render(statsNav({
      selector: this.selector,
      onToggle: ev => this.toggleStatsSelector(ev),
      onResize: action => this.resizeStatsPanel(action)
    }), this.dom);

    state.channel.subscribe("onResizePanel", () => {
      if (state.panelLayout.isStatsMin()) {
        this.dom.parentNode.classList.add("panel-min");
        this.dom.parentNode.classList.remove("panel-max");
      } else if (state.panelLayout.isStatsMax()) {
        this.dom.parentNode.classList.add("panel-max");
        this.dom.parentNode.classList.remove("panel-min");
      } else {
        this.dom.parentNode.classList.remove("panel-max");
        this.dom.parentNode.classList.remove("panel-min");
      }
    });
  }

  toggleStatsSelector(ev) {
    const [group, value] = ev.target.id.split("-");

    if (group == "count") {
      this.selector.count = ev.target.checked ? value : "";
    } else {
      this.selector[group] = value;
    }

    const statsKey = [
      this.selector.frequency,
      this.selector.metric,
      this.selector.count
    ].filter(Boolean).join("_");

    state.channel.publish("onStatsSelected", statsKey);
  }

  resizeStatsPanel(action) {
    state.panelLayout.resizeStats(action);
    state.channel.publish("onResizePanel");
  }
}

export default StatsNavView;
